/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExcelConnectionConfig } from '../../models/excel-connection-config';
import { ExcelConnectionConfigCreate } from '../../models/excel-connection-config-create';

export interface UpdateExcelConnectionConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected excel connection configuration
 */
  excelUid: string;
  
    /**
     * The Excel connection create object
     */
    body: ExcelConnectionConfigCreate
}

export function updateExcelConnectionConfiguration(http: HttpClient, rootUrl: string, params: UpdateExcelConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ExcelConnectionConfig>> {
  const rb = new RequestBuilder(rootUrl, updateExcelConnectionConfiguration.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('excelUid', params.excelUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExcelConnectionConfig>;
    })
  );
}

updateExcelConnectionConfiguration.PATH = '/stations/{uid}/excel/{excelUid}';
